<template>
  <b-modal @hide="modalClose" ref="revisionModal" :title="$t('複製して改訂')" size="md">
    <b-container fluid>
      <table class="table table-bordered my-3">
        <tbody class="tbody">
          <tr>
            <th class="table-active text-left">{{ $t('新改訂') }}
              <span class="text-danger">&nbsp;{{ $t("※必須") }}</span>
            </th>
            <td class="text-left">
              <input v-model="form.version" type="text" class="form-control input" />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('複製対象：図面/画像') }}</th>
            <td class="text-left">
              <input v-model="form.file" type="checkbox" class="form-control input" />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('複製対象：製品形状') }}</th>
            <td class="text-left">
              <input v-model="form.shape" type="checkbox" class="form-control input" />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('複製対象：材料') }}</th>
            <td class="text-left">
              <input v-model="form.material" type="checkbox" class="form-control input" />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('複製対象：標準工程') }}</th>
            <td class="text-left">
              <input v-model="form.baseProcess" type="checkbox" class="form-control input" />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('複製対象：構成部品表') }}</th>
            <td class="text-left">
              <input v-model="form.structure" type="checkbox" class="form-control input" />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('複製対象：在庫情報') }}</th>
            <td class="text-left">
              <input v-model="form.inventory" type="checkbox" class="form-control input" />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('複製対象：コスト情報') }}</th>
            <td class="text-left">
              <input v-model="form.cost" type="checkbox" class="form-control input" />
            </td>
          </tr>
          <tr>
            <th class="table-active text-left">{{ $t('複製対象：取引先') }}</th>
            <td class="text-left">
              <input v-model="form.partner" type="checkbox" class="form-control input" />
            </td>
          </tr>
          <!-- <tr>
            <th class="table-active text-left">{{ $t('複製対象：材料仕入先') }}</th>
            <td class="text-left">
              <input v-model="form.materialPartner" type="checkbox" class="form-control input" />
            </td>
          </tr> -->
        </tbody>
      </table>
    </b-container>
    <template v-slot:modal-footer>
      <p class="text-danger text-center" v-if="error">{{ error }}</p>
      <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
        <button
          type="button"
          class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
          :disabled="registering"
          @click="register()"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t('登録') }}
        </button>
        <button
          type="button"
          class="btn btn-light"
          :disabled="registering"
          @click="modalClose()"
        >{{ $t('キャンセル') }}</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      form: {
        productId: null,
        version: '',
        file: false,
        shape: false,
        material: false,
        baseProcess: false,
        structure: false,
        inventory: false,
        cost: false,
        partner: false,
        // materialPartner: false,
      },
      error: '',
      registering: false,
    }
  },
  methods: {
    // モーダルを開いたときの処理
    modalOpen(id) {
      this.$refs.revisionModal.show()
      this.form.productId = id
    },
    // モーダルを閉じるときの処理
    modalClose() {
      this.$emit('modalClose')
      this.$refs.revisionModal.hide()
    },
    async register() {
      if (this.isEmpty(this.form.version)) return this.error = this.$t('新改訂') + this.$t('必須メッセージ')
      this.error = ''
      this.registering = true
      try {
        await this.$axios.post(
          `${this.$appConfig.CommonApiUrl}/product/copy`,
          this.form,
          {
            headers: {
              Authorization: this.authorization ? this.authorization : null,
            },
          }
        )
        this.$toasted.success('複製が完了しました。')
        this.$refs.revisionModal.hide()
        this.form = {
          productId: null,
          version: '',
        }
      } catch (error) {
        this.$toasted.show('データ登録エラーメッセージ')
      }
      this.registering = false
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>
